import { Icon } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router-dom';
import VerifyPhoneButton from '~/components/VerifyPhoneButton';
import { useFullRoutes } from '~/hooks';
import { useGetUserProfileQuery } from '~/redux/api/authApiSlice';

const UserPhoneNumber = () => {
  const { MY_ACCOUNT_URL } = useFullRoutes();
  const { t } = useTranslation('app');
  const { data: userProfile } = useGetUserProfileQuery();
  const [searchParams] = useSearchParams();
  const hasPassword = userProfile?.has_password;
  const hasPhone = userProfile?.phone;

  return (
    <div className="flex flex-col gap-1.5x">
      <div className="pt-2x px-3x flex">
        <div className="flex flex-col gap-x flex-1">
          <div className="flex gap-1.5x items-center	">
            <p className="text-title_4">{t('phoneNumber')}</p>
            {userProfile?.phone ? <VerifyPhoneButton /> : <></>}
          </div>
          <p className="text-body_1 text-gray__dark_1">
            {userProfile?.phone ?? t('unAvailable')}
          </p>
        </div>
        {hasPassword ? (
          <Link
            to={`${MY_ACCOUNT_URL.UPDATE_PHONE}?${searchParams.toString()}`}
          >
            <Icon
              name={hasPhone ? 'edit' : 'plus'}
              className={hasPassword ? 'text-blue' : 'text-gray'}
            />
          </Link>
        ) : (
          <Icon
            name={hasPhone ? 'edit' : 'plus'}
            className={hasPassword ? 'text-blue' : 'text-gray'}
          />
        )}
      </div>
      {!hasPassword && (
        <div className="bg-orange_light_2 mx-2x p-1.5x rounded-[8px] gap-1 inline-block">
          <span className="text-body_1 text-orange_dark_2">
            {t('addMobileInstruction')}
          </span>
          <Link
            to={`${MY_ACCOUNT_URL.UPDATE_PASSWORD}?${searchParams.toString()}`}
            className="text-link text-blue inline-block mx-x"
          >
            {t('setPassword')}
          </Link>
        </div>
      )}
    </div>
  );
};

export default UserPhoneNumber;
